import { render, staticRenderFns } from "./FormAnswer.vue?vue&type=template&id=cd552a74&scoped=true&"
import script from "./FormAnswer.vue?vue&type=script&lang=js&"
export * from "./FormAnswer.vue?vue&type=script&lang=js&"
import style0 from "./FormAnswer.vue?vue&type=style&index=0&id=cd552a74&lang=scss&scoped=true&"
import style1 from "./FormAnswer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd552a74",
  null
  
)

export default component.exports